module.exports = __webpack_public_path__ + "img/icon-bid_file_analysis.0bba3296.png";